import {
  processExpressions,
  processSetValue,
  processValidation,
} from './processors';
import { EventContext } from './types';

export const dataEventModel = () => (() => ({
  buildContext: ({ ...expressions }): EventContext => ({
    form: expressions.form,
    valuesForConditions: expressions.valuesForCondition,
    engine: expressions.engine,
    getFeatureVariables: expressions.getFeatureVariables,
    onChange: expressions.onChange,
    currentRecord: expressions.record,
    elementsByKey: expressions.elementsByKey,
  }),
  processExpressions,
  processSetValue,
  processValidation,
}))();

export default dataEventModel;
